import {createAction, handleActions} from 'redux-actions';
import {Api} from "../../api/api";
import {fetchSubmitForm, fetchSubmitFormFailed, fetchSubmitFormSuccess} from '../common/submitForm';
import {logout, onForbidden} from '../account/login';
import _ from 'lodash';
import {LOCATION_MAP, TRANSACTION_TYPES} from "../../constants/constants";
import {hideModal} from '../common/activeModal';
import {getCountriesData} from "../common/location";

//- Actions
export const fetchGetDuePaymentsForBAsFailed = createAction('FETCH_GET_BA_S_DUE_PAYMENTS_FAILED');
export const fetchGetDuePaymentsForBAsSuccess = createAction('FETCH_GET_BA_S_DUE_PAYMENTS_SUCCESS');
export const onFetchGetDuePaymentsForBAs = createAction(
    'FETCH_GET_BA_S_DUE_PAYMENTS',
    (countries, name) => Api.getDuePaymentsForBAs(countries, name),
    () => ({
        apiCall: true,
        onSuccess: fetchGetDuePaymentsForBAsSuccess,
        onFail: fetchGetDuePaymentsForBAsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchGetDuePaymentsForBAs = () => (dispatch, getState) => {
    let continentFilter = getContinentFilterForBAsDuePayments(getState());
    let countries = LOCATION_MAP[continentFilter];
    let name = getNameFilterForBAsDuePayments(getState());
    dispatch(onFetchGetDuePaymentsForBAs(countries, name));
};

export const fetchPayDuePaymentsForBASuccess = () => (dispatch) => {
    dispatch(fetchSubmitFormSuccess());
    dispatch(hideModal());
    dispatch(fetchGetDuePaymentsForBAs());
};
export const onFetchPayDuePaymentsForBA = createAction(
    'FETCH_PAY_BA_DUE_PAYMENTS',
    (id, data) => Api.payDuePaymentsForBA(id, data),
    () => ({
        apiCall: true,
        onSuccess: fetchPayDuePaymentsForBASuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchPayDuePaymentsForBA = (id, data) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(onFetchPayDuePaymentsForBA(id, data));
};

export const onUpdateContinentFilterForBAsDuePayments = createAction('UPDATE_CONTINENT_FILTER_FOR_BA_S_DUE_PAYMENTS');
export const updateContinentFilterForBAsDuePayments = (continentFilter) => (dispatch, getState) => {
    let countries = LOCATION_MAP[continentFilter];
    let name = getNameFilterForBAsDuePayments(getState());
    dispatch(onFetchGetDuePaymentsForBAs(countries, name));
    dispatch(onUpdateContinentFilterForBAsDuePayments(continentFilter));
};

export const fetchGetDuePaymentsForUniversitiesFailed = createAction('FETCH_GET_UNI_S_DUE_PAYMENTS_FAILED');
export const fetchGetDuePaymentsForUniversitiesSuccess = createAction('FETCH_GET_UNI_S_DUE_PAYMENTS_SUCCESS');
export const onGetDuePaymentsForUniversitiesSuccess = (data) => (dispatch) => {
    let isEmpty = data.empty;
    let currentPage = data.number;
    if ((!isEmpty && currentPage !== 0) || currentPage === 0) {
        dispatch(fetchGetDuePaymentsForUniversitiesSuccess(data));
    } else {
        dispatch(fetchGetDuePaymentsForUniversities(currentPage - 1));
    }
};
export const onFetchGetDuePaymentsForUniversities = createAction(
    'FETCH_GET_UNI_S_DUE_PAYMENTS',
    (page, countries, name) => Api.getDuePaymentsForUniversities(page, countries, name),
    () => ({
        apiCall: true,
        onSuccess: onGetDuePaymentsForUniversitiesSuccess,
        onFail: fetchGetDuePaymentsForUniversitiesFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchGetDuePaymentsForUniversities = (page) => (dispatch, getState) => {
    let countryCode = getCountryFilterForUniversitiesDuePayments(getState());
    let name = getNameFilterForUniversitiesDuePayments(getState());
    dispatch(onFetchGetDuePaymentsForUniversities(page, !_.isNil(countryCode) ? [countryCode] : null, name));
};

export const fetchPayDuePaymentsForUniversitySuccess = () => (dispatch, getState) => {
    dispatch(fetchSubmitFormSuccess());
    dispatch(hideModal());
    let currentPage = getCurrentPageForUniversitiesDuePayments(getState());
    dispatch(fetchGetDuePaymentsForUniversities(currentPage));
};
export const onFetchPayDuePaymentsForUniversity = createAction(
    'FETCH_PAY_UNI_DUE_PAYMENTS',
    (id, data) => Api.payDuePaymentsForUniversity(id, data),
    () => ({
        apiCall: true,
        onSuccess: fetchPayDuePaymentsForUniversitySuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchPayDuePaymentsForUniversity = (id, data) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(onFetchPayDuePaymentsForUniversity(id, data));
};

export const onUpdateCountryFilterForUniversitiesDuePayments = createAction('UPDATE_CONTINENT_FILTER_FOR_UNI_S_DUE_PAYMENTS');
export const updateCountryFilterForUniversitiesDuePayments = (countryCode) => (dispatch, getState) => {
    let countriesList = countryCode ? [countryCode] : getCountriesData(getState());
    let currentPage = getCurrentPageForUniversitiesDuePayments(getState());
    let name = getNameFilterForUniversitiesDuePayments(getState());
    dispatch(onFetchGetDuePaymentsForUniversities(currentPage, countriesList, name));
    dispatch(onUpdateCountryFilterForUniversitiesDuePayments(countryCode));
};

export const fetchGetDuePaymentsForSystemFailed = createAction('FETCH_GET_SYSTEM_DUE_PAYMENTS_FAILED');
export const fetchGetDuePaymentsForSystemSuccess = createAction('FETCH_GET_SYSTEM_DUE_PAYMENTS_SUCCESS');
export const onFetchGetDuePaymentsForSystem = createAction(
    'FETCH_GET_SYSTEM_DUE_PAYMENTS',
    () => Api.getDuePaymentsForSystem(),
    () => ({
        apiCall: true,
        onSuccess: fetchGetDuePaymentsForSystemSuccess,
        onFail: fetchGetDuePaymentsForSystemFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchPayDuePaymentForSystemSuccess = () => (dispatch) => {
    dispatch(fetchSubmitFormSuccess());
    dispatch(hideModal());
    dispatch(onFetchGetDuePaymentsForSystem());
};
export const onFetchPayDuePaymentsForSystem = createAction(
    'FETCH_PAY_SYSTEM_DUE_PAYMENTS',
    (data) => Api.payDuePaymentForSystem(data),
    () => ({
        apiCall: true,
        onSuccess: fetchPayDuePaymentForSystemSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchPayDuePaymentsForSystem = (data) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(onFetchPayDuePaymentsForSystem(data));
};

export const setNameFilterForBAsDuePayments = createAction('NAME_FILTER_FOR_BAS_DUE_PAYMENTS_SET');
export const updateNameFilterForBAsDuePayments = (name) => (dispatch, getState) => {
    let continentFilter = getContinentFilterForBAsDuePayments(getState());
    let countries = LOCATION_MAP[continentFilter];
    dispatch(onFetchGetDuePaymentsForBAs(countries, name));
    dispatch(setNameFilterForBAsDuePayments(name));
};

export const setNameFilterForUniversitiesDuePayments = createAction('NAME_FILTER_FOR_UNIVERSITIES_DUE_PAYMENTS_SET');
export const updateNameFilterForUniversitiesDuePayments = (name) => (dispatch, getState) => {
    let countryCode = getCountryFilterForUniversitiesDuePayments(getState());
    let currentPage = getCurrentPageForUniversitiesDuePayments(getState());
    dispatch(onFetchGetDuePaymentsForUniversities(currentPage, !_.isNil(countryCode) ? [countryCode] : null, name));
    dispatch(setNameFilterForUniversitiesDuePayments(name));
}

//- State
const initialState = {
    BAsData: null,
    BAsContinentFilter: null,
    BAsFetching: false,
    BAsError: null,
    BAsNameFilter: '',
    universitiesData: null,
    universitiesCountryFilter: null,
    universitiesFetching: false,
    universitiesError: null,
    universitiesCurrentPage: null,
    universitiesTotalPages: null,
    universitiesNameFilter: '',
    systemData: null,
    systemFetching: false,
    systemError: null,
};

//- Reducers
export default handleActions({
    FETCH_GET_BA_S_DUE_PAYMENTS: (state) => {
        return {...state, BAsData: null, BAsError: null, BAsFetching: true};
    },
    FETCH_GET_BA_S_DUE_PAYMENTS_FAILED: (state, action) => {
        return {...state, BAsData: null, BAsError: action.payload, BAsFetching: false};
    },
    FETCH_GET_BA_S_DUE_PAYMENTS_SUCCESS: (state, action) => {
        return {
            ...state,
            BAsData: action.payload.content,
            BAsError: null,
            BAsFetching: false
        };
    },
    FETCH_GET_UNI_S_DUE_PAYMENTS: (state) => {
        return {
            ...state,
            universitiesData: null,
            universitiesCurrentPage: null,
            universitiesTotalPages: null,
            universitiesError: null,
            universitiesFetching: true
        };
    },
    FETCH_GET_UNI_S_DUE_PAYMENTS_FAILED: (state, action) => {
        return {
            ...state,
            universitiesData: null,
            universitiesCurrentPage: null,
            universitiesTotalPages: null,
            universitiesError: action.payload,
            universitiesFetching: false
        };
    },
    FETCH_GET_UNI_S_DUE_PAYMENTS_SUCCESS: (state, action) => {
        return {
            ...state,
            universitiesData: action.payload.content,
            universitiesCurrentPage: action.payload.number,
            universitiesTotalPages: action.payload.totalPages,
            universitiesError: null,
            universitiesFetching: false
        };
    },
    UPDATE_CONTINENT_FILTER_FOR_BA_S_DUE_PAYMENTS: (state, action) => {
        return {...state, BAsContinentFilter: action.payload};
    },
    UPDATE_CONTINENT_FILTER_FOR_UNI_S_DUE_PAYMENTS: (state, action) => {
        return {...state, universitiesCountryFilter: action.payload};
    },
    FETCH_GET_SYSTEM_DUE_PAYMENTS: (state) => {
        return {...state, systemData: null, systemFetching: true, systemError: null};
    },
    FETCH_GET_SYSTEM_DUE_PAYMENTS_SUCCESS: (state, action) => {
        return {...state, systemData: action.payload, systemFetching: false, systemError: null};
    },
    FETCH_GET_SYSTEM_DUE_PAYMENTS_FAILED: (state, action) => {
        return {...state, systemFetching: false, systemError: action.payload};
    },
    NAME_FILTER_FOR_BAS_DUE_PAYMENTS_SET: (state, action) => {
        return {...state, BAsNameFilter: action.payload};
    },
    NAME_FILTER_FOR_UNIVERSITIES_DUE_PAYMENTS_SET: (state, action) => {
        return {...state, universitiesNameFilter: action.payload};
    }

}, initialState);

//- Selectors
export const getDuePayments = state => state.duePayments;

export const loadingBAsDuePayments = state => getDuePayments(state).BAsFetching;

export const getBAsDuePaymentsData = state => {
    let data = getDuePayments(state).BAsData;
    if (_.isNil(data)) {
        return null;
    }

    return _.map(data, elem => {
        let total = [];

        let transactionsByType = elem.transactionStatistic[TRANSACTION_TYPES.PAYED_CONSENT_REQUEST_REMUNERATION] || [];
        _.forEach(transactionsByType, transaction => {
            let index = total.findIndex(el => el.currency === transaction.currency);
            if (index !== -1) {
                total[index].amount -= transaction.amount;
            } else {
                total.push({
                    currency: transaction.currency,
                    amount: Math.abs(transaction.amount)
                });
            }
        });

        return {
            id: elem.target.id,
            name: elem.target.firstName + " " + elem.target.lastName,
            paymentAmount: elem.target.balance,
            totalPay: total,
            wireData: elem.target.financialData
        }
    });
};

export const getContinentFilterForBAsDuePayments = state => getDuePayments(state).BAsContinentFilter;

export const loadingUniversitiesDuePayments = state => getDuePayments(state).universitiesFetching;

export const getCurrentPageForUniversitiesDuePayments = state => getDuePayments(state).universitiesCurrentPage;

export const getTotalPagesForUniversitiesDuePayments = state => getDuePayments(state).universitiesTotalPages;

export const getUniversitiesDuePaymentsData = state => {
    let data = getDuePayments(state).universitiesData;
    if (_.isNil(data)) {
        return null;
    }

    return _.map(data, elem => {
        let total = [];

        let transactionsByType = elem.transactionStatistic[TRANSACTION_TYPES.PAYED_CONSENT_REQUEST_REMUNERATION] || [];
        _.forEach(transactionsByType, transaction => {
            let index = total.findIndex(el => el.currency === transaction.currency);
            if (index !== -1) {
                total[index].amount -= transaction.amount;
            } else {
                total.push({
                    currency: transaction.currency,
                    amount: -transaction.amount
                });
            }
        });

        return {
            id: elem.target.id,
            name: elem.target.name,
            paymentAmount: elem.target.balance,
            totalPay: total,
            wireData: elem.target.financialData
        }
    });
};

export const getCountryFilterForUniversitiesDuePayments = state => getDuePayments(state).universitiesCountryFilter;

export const getSystemDuePayments = state => {
    let data = getDuePayments(state).systemData;

    if (_.isNil(data)) {
        return null;
    }

    let total = [];

    let transactionsByType = data.transactionStatistic[TRANSACTION_TYPES.PAYED_CONSENT_REQUEST_REMUNERATION] || [];
    _.forEach(transactionsByType, transaction => {
        let index = total.findIndex(el => el.currency === transaction.currency);
        if (index !== -1) {
            total[index].amount -= transaction.amount;
        } else {
            total.push({
                currency: transaction.currency,
                amount: -transaction.amount
            });
        }
    });

    return [{
        id: data.target.id,
        paymentAmount: data.target.balance,
        totalPay: total,
    }];
};

export const loadingSystemDuePayments = state => getDuePayments(state).systemFetching;

export const getNameFilterForBAsDuePayments = state => getDuePayments(state).BAsNameFilter;

export const getNameFilterForUniversitiesDuePayments = state => getDuePayments(state).universitiesNameFilter;


// WEBPACK FOOTER //
// ./src/reducers/systemPayments/duePayments.js